document.addEventListener('change', (e) => {
  const proxySort = e.target.closest('.sort_mobile-new select');
  if (!proxySort) return;

  const realSort = document.querySelector(
    '.drawer-real-sorting select'
  );

  if (!realSort) return;

  realSort.value = proxySort.value;
  realSort.dispatchEvent(new Event('change', { bubbles: true }));
});